import React from 'react';
import styles from './popup.scss';

const MatchedProfilePopup = (props) => {
    const { topPoint, title, description, showPopupContinue } = props;

    return (
        <div
            className={styles.popup}
            style={topPoint ? {
                top: topPoint.toString(),
                transform: 'translateX(50%)',
                right: '50%',
            } : {}}
        >
            <div className={styles.popup_inner}>
                <div className={styles.gradientBar} />
                <div className={styles.popupContent}>
                    <h5 className={styles.popupTitle}>{title}</h5>
                    <div className={styles.popupText} dangerouslySetInnerHTML={{ __html: description }} />

                    {showPopupContinue && (
                        <div className={`text-right ${styles.popupFooter}`}>
                            <button
                                type="button"
                                className={`btn btn-default btn-sm text-uppercase`}
                                onClick={props.closePopup}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className={`btn btn-primary btn-sm text-uppercase`}
                                onClick={props.confirmPopup}
                            >
                                Confirm
                            </button>
                        </div>
                    )}
                    {!showPopupContinue && (
                        <div className={`text-right ${styles.popupFooter}`}>
                            <button
                                type="button"
                                className={`btn btn-default btn-sm text-uppercase`}
                                onClick={props.closePopup}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MatchedProfilePopup;
